export default {
  me: null,
}
